<template>
    <div :class="`row tile padding-${paddingAmount} ${border}`">
        <slot name="content"></slot>
    </div>
</template>


<script>
export default {
    props: {
        paddingAmount: {
            default: 1
        },
        showBorder: {
            required: false,
            default: true
        }
    },

    data() {
        return {
        }
    },
    computed: {
        border() {
            return this.showBorder ? 'border' : 'no-border';
        }
    }
}
</script>


<style scoped>

    .padding-0 {
        padding: 0px;
    }

    .padding-1 {
        padding: 10px;
    }

    .padding-2 {
        padding: 20px;
    }
    
    .padding-3 {
        padding: 30px;
    }

    .border {
        border: 3px solid #0384FB;
    }

    .no-border {
        border: 3px solid white;
    }

    .tile {
        margin: 50px 0 30px -1px;
        width: 100%;
        border-radius: 15px;
        box-shadow: 0 4px 8px 4px rgba(0, 0, 0, 0.1);
        background: #fff;
    }
</style>